const COOKIES = {
  PUBLIC_INVITE_DATA: "publicInviteData",
};

Object.freeze(COOKIES);

export { COOKIES };
